import { useState } from "react";
import httpService from "../services/httpService";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { FaCircleNotch } from "react-icons/fa";

const TestImage = () => {
    const [keyTakeawayId, setKeyTakeawayId] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setData(null);
        setLoading(true);
        try {
            const res = await httpService.post(`dash/key-takeaway/${keyTakeawayId}/generate-image`);
            if (res.data.status) {
                setData(res.data);
            }
        } catch (err) {
            setData(null);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={'page test py-5'}>
            <Container className={"py-5"}>
                <Form onSubmit={handleSubmit}>
                    <Row className="align-items-end">
                        <Col sm={4} className="mb-3">
                            <Form.Group controlId="keyTakeawayId">
                                <Form.Label>Key Takeaway ID</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={keyTakeawayId}
                                    placeholder="Enter key takeaway ID"
                                    disabled={loading}
                                    onChange={(e) => setKeyTakeawayId(e.target.value)}
                                    min={1}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={2} className="mb-3">
                            <Button
                                disabled={loading || !keyTakeawayId}
                                className="w-100"
                                variant="light"
                                type="submit"
                            >
                                Generate Image
                            </Button>
                        </Col>
                    </Row>
                </Form>

                {loading && (
                    <div className={'text-center py-5'}>
                        <FaCircleNotch size="50" className="fa-spin loading_spinner" />
                    </div>
                )}

                {!loading && data && (
                    <Row className="mt-4 g-4">
                        <Col sm={12} md={8} lg={6}>
                            <img
                                src={`data:image/png;base64,${data.image}`}
                                alt="Generated key takeaway"
                                className="img-fluid rounded w-100"
                            />
                        </Col>
                        <Col sm={12} md={8} lg={6}>
                            <Card className="mb-3">
                                <Card.Body>
                                    <Card.Subtitle className="text-muted mb-1">Podcast Club</Card.Subtitle>
                                    <Card.Title>{data.podcast_club_title}</Card.Title>
                                    <Card.Text>{data.podcast_club_description}</Card.Text>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Body>
                                    <Card.Subtitle className="text-muted mb-1">Episode</Card.Subtitle>
                                    <Card.Title>{data.episode_title}</Card.Title>
                                    <Card.Text>{data.episode_description}</Card.Text>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Body>
                                    <Card.Subtitle className="text-muted mb-1">Key Takeaway</Card.Subtitle>
                                    <Card.Title>{data.key_takeaway_title}</Card.Title>
                                    <Card.Text>{data.key_takeaway_insight}</Card.Text>
                                    {data.key_takeaway_quote && (
                                        <blockquote className="blockquote mb-0">
                                            <p className="fst-italic">"{data.key_takeaway_quote}"</p>
                                        </blockquote>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
};

export default TestImage;
